import { cn } from '@repo/ui/lib/utils';

export function Section({
  children,
  id,
  className,
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) {
  return (
    <section
      className={cn(
        'relative w-full px-4 sm:px-8 md:px-16 lg:px-20 py-8 md:py-16 lg:py-24 xl:py-32 overflow-hidden',
        className
      )}
      id={id}
    >
      {children}
    </section>
  );
}
